import React from 'react';
import { FormattedMessage } from 'react-intl';
import { EnterpriseOpponents } from './EnterpriseOpponents';
import { EnterpriseEvolution } from './EnterpriseEvolution';
import { withUser } from '../../user/UserContext';
import { UserContextType } from '../../user/user.types';
import { withEnterprise } from './EnterpriseContext';
import { EnterpriseContextType } from './enterprise.types';

type Props = UserContextType & EnterpriseContextType;

type State = {
  shouldDisplayTitle: boolean;
};

export class RawEnterpriseOpponentsAndEvolution extends React.Component<
  Props,
  State
> {
  state: State = {
    shouldDisplayTitle: false,
  };

  id = 'enterprise-opponents';

  displayTitle = () => {
    this.setState({ shouldDisplayTitle: true }, () => {
      window.dispatchEvent(
        new CustomEvent('createNav', {
          detail: this.id,
        }),
      );
    });
  };

  render() {
    const {
      enterpriseInfos: { raisonSociale },
      loggedIn,
    } = this.props;
    const { shouldDisplayTitle } = this.state;
    return (
      <>
        {shouldDisplayTitle && (
          <h2 id={this.id} className="entity__section-title">
            <FormattedMessage
              id="app.pages.enterprise.opponents.sectionTitle"
              values={{ enterpriseName: raisonSociale }}
            />
          </h2>
        )}
        <EnterpriseOpponents displayTitle={this.displayTitle} />
        {loggedIn && <EnterpriseEvolution displayTitle={this.displayTitle} />}
      </>
    );
  }
}

export const EnterpriseOpponentsAndEvolution = withEnterprise(
  withUser(RawEnterpriseOpponentsAndEvolution),
);
